<template>
  <div>
    <slot></slot>
    <transition name="fade">
      <div v-if="filter" class="loader-container">
        <filter-wrapper :has-active-discounts="hasActiveDiscounts" :has-new-arrivals="hasNewArrivals"></filter-wrapper>
      </div>
    </transition>

    <tags-filter></tags-filter>
    <transition name="fade">
      <products-component :type="type">
        <transition name="fade">
          <features-filter v-show="type === 'seeds'" :filter-open="filterOpen" v-on:close-filter="closeFilter"></features-filter>
        </transition>
        <div v-if="type === 'seeds'" class="floating-filter">
          <button @click="openFilter" class="btn btn-primary flex items-center justify-center gap-x-2">{{ trans.get('our-seeds.filters') }} <img src="/img/icons/filter.svg" alt="filter"></button>
        </div>
      </products-component>
    </transition>
  </div>
</template>

<script>
import Products from "./Products";
import FilterWrapper from "./FilterWrapper";
import TagsFilter from "./TagsFilter.vue";
import FeaturesFilter from "./FeaturesFilter.vue";
import {
  RETREIVE_PRODUCTS_ACTION,
  GET_PRODUCTS,
  RETREIVE_CATEGORIES_ACTION,
  SET_FILTER_TYPE_ACTION
} from "../../store/shop/types";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ProductsComponent: Products,
    FilterWrapper: FilterWrapper,
    FeaturesFilter: FeaturesFilter,
    TagsFilter: TagsFilter
  },
  data: () => {
    return {
        filterOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      items: GET_PRODUCTS,
    }),
    isMobile(){
      return window.innerWidth < 992;
    }
  },
  props: {
    type: String,
    filter: {
      type: Boolean,
      default: false
    },
    hasActiveDiscounts: {
        default: false,
        type: Boolean
    },
    hasNewArrivals: {
        default: false,
        type: Boolean
    }
  },
  methods: {
    openFilter(){
      document.body.style.overflow = 'hidden';
      this.filterOpen = true;
    },
    closeFilter(){
      document.body.style.overflow = '';
      this.filterOpen = false;
    },
    ...mapActions({
      setTypeFilter: SET_FILTER_TYPE_ACTION,
      retreiveProducts: RETREIVE_PRODUCTS_ACTION,
      retreiveCategories: RETREIVE_CATEGORIES_ACTION,
    }),
  },
  async created() {
    this.setTypeFilter(this.type);
    this.retreiveCategories();
    await this.retreiveProducts();
}

};
</script>

<style lang="scss" scoped>

.floating-filter{
  @media(min-width: 992px){
    display: none;
  }
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: center;
  bottom: 30px;
  left: 0;
  z-index: 10;
  .btn{
    width: 75%;
  }

}
.loader-container {
  min-height: 26.6px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease; 
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
